module.exports = __webpack_public_path__ + "img/ico_terrible_simple.8dfbdde5.svg";